import * as React from 'react'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'

const Context = React.createContext<ContractVersions | null | undefined>(null)

export const ContractVersionsProvider = ({
  collection,
  children,
}: {
  collection: ContractVersions
  children: React.ReactNode
}) => <Context.Provider value={collection}>{children}</Context.Provider>

export const useContractVersions = (): ContractVersions => {
  const contractVersions = React.useContext(Context)

  if (!contractVersions) {
    throw new Error('useContractVersions must be used within a ContractVersionsProvider')
  }

  return contractVersions
}
